import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconStratigraphySizeS from './IconStratigraphy_size_s';

const props: CreateIconArguments = {
  l: IconStratigraphySizeS,
  m: IconStratigraphySizeS,
  s: IconStratigraphySizeS,
  xs: IconStratigraphySizeS,
  name: 'IconStratigraphy',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
